import styled, { css } from 'styled-components';

interface ContainerProps {
  error: boolean;
  success: boolean;
}

export const Container = styled.div<ContainerProps>`
  z-index: inherit;

  .input-wrapper {
    position: relative;
    width: 100%;
    height: 40px;
    display: flex;
    background-color: transparent;
    border: 1px solid
      ${props => (props.theme.title === 'light' ? '#7a7a7a' : '#2B2B40')} !important;
    border-radius: 4px;
    padding-right: 0;
    isolation: isolate;

    &:hover {
      transition: border 0.5s;
      border-color: ${props =>
        props.title === 'light' ? '#0095e8' : '#187DE4'} !important;
    }

    &:focus {
      background-color: ${props => props.theme.colors.input};
    }

    input {
      flex: 1;
      height: 100%;
      background: transparent;
      padding-left: 10px;
      padding-right: 10px;
      font-size: 13px;
      color: #555555 !important;
      cursor: pointer;
      z-index: 2;

      &:hover {
        border-color: ${props =>
          props.title === 'light' ? '#0095e8' : '#187DE4'} !important;
      }

      &:focus,
      &:hover {
        border-color: ${props =>
          props.title === 'light' ? '#0095e8' : '#187DE4'} !important;
      }
      ${props =>
        props.error &&
        css`
          border-color: ${!props.error ? '#2684ff' : '#e12325'};
          box-shadow: 0 0 0 0.5px ${!props.error ? '#2684ff' : '#e12325'};
        `}

      &::-webkit-calendar-picker-indicator {
        background: transparent;
        bottom: 0;
        color: transparent;
        cursor: pointer;
        height: auto;
        left: 0;
        position: absolute;
        right: 0;
        top: 0;
        width: 100%;
      }

      &::placeholder {
        font-size: 13px;
        line-height: 45px;
        font-weight: 400;
        color: #b0b0b0;
      }
    }
    .icon {
      width: 40px;
      height: 100%;
      position: absolute;
      right: 5px;
      display: grid;
      place-items: center;
      z-index: 1;
      cursor: pointer;
    }
  }
`;
